(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"), require("@emotion/react"));
	else if(typeof define === 'function' && define.amd)
		define("DecapCmsWidgetDatetime", ["react", "prop-types", "@emotion/react"], factory);
	else if(typeof exports === 'object')
		exports["DecapCmsWidgetDatetime"] = factory(require("react"), require("prop-types"), require("@emotion/react"));
	else
		root["DecapCmsWidgetDatetime"] = factory(root["React"], root["DecapCmsDefaultExports"]["PropTypes"], root["DecapCmsDefaultExports"]["EmotionCore"]);
})(window, (__WEBPACK_EXTERNAL_MODULE__119__, __WEBPACK_EXTERNAL_MODULE__434__, __WEBPACK_EXTERNAL_MODULE__110__) => {
return 